import { useFeatureFlags } from "@climatepartner/app-shell/feature-flags";

import { FeatureToggleKey, FeatureToggles } from "./feature-toggles";

type FeatureToggleResult<T extends FeatureToggleKey> = {
  enabled: boolean;
  featureToggles: Pick<FeatureToggles, T>;
};
export const useFeatureToggles = function useFeatureToggles<T extends FeatureToggleKey>(
  ...featureToggleKeys: Extract<FeatureToggleKey, T>[]
): FeatureToggleResult<T> {
  const { flags } = useFeatureFlags();
  return featureToggleKeys.reduce(
    (acc, key) => {
      const value = flags[key] ?? false;
      acc.enabled = acc.enabled && value;
      acc.featureToggles[key] = value;
      return acc;
    },
    { enabled: true, featureToggles: {} } as FeatureToggleResult<T>
  );
};
